import { Fragment } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Link } from "react-router-dom"
import "./Home.css";
import Carttslice from "../store/Carttslice";

const Cartt = ()=>{
    const dispatch = useDispatch();
    const cartvalue = useSelector((store) => {
        return store.cartt.items

    })
    return(
        <Fragment>
            {cartvalue.length===0 ? 
                <h2 className="mt-5">Your Cart is Empty</h2> :
                <Fragment>
                     <h2 className="mt-5">Your Cart: <b>{cartvalue.length} items</b></h2>
                    <div className="row d-flex justify-content-between">
                        <div className="col-12 col-lg-8">
                            {cartvalue.map(item => (
                                <Fragment key={item.num}>
                                    <hr />
                                    <div className="cart-item">
                                        <div className="row">
                                            <div className="col-4 col-lg-3">
                                                <img src={item.img} alt={item.title} height="90" width="115"/>
                                            </div>

                                            <div className="col-5 col-lg-3">
                                                <h3><Link to={`/product/${item.num}`} className="carttitle">{item.title}</Link></h3>
                                                 <h5> <i>Stock : {item.stock} </i>  </h5>
                                                
                                            </div>


                                            <div className="col-4 col-lg-2 mt-4 mt-lg-0">
                                                <h5 id="card_item_price" className="mt-2">{item.Price}</h5>
                                            </div>

                                            <div className="col-4 col-lg-3 mt-4 mt-lg-0">
                                                <div className="stockCounter d-inline">
                                                    <span className="btn btn-danger minus" onClick={()=>{dispatch(Carttslice.actions.decreaseCartQty(item.num))}}  >-</span>
                                                    <input type="number" className="form-control count d-inline" value={item.quantity} readOnly />

                                                    <span className="btn btn-primary plus" onClick={()=>{dispatch(Carttslice.actions.increaseCartQty(item.num))}} >+</span>
                                                </div>
                                            </div>

                                            <div className="col-4 col-lg-1 mt-4 mt-lg-0">
                                                <i id="delete_cart_item" onClick={()=>{dispatch(Carttslice.actions.removefromcartt(item.num))}} className="fa fa-trash btn btn-danger"></i>
                                            </div>

                                        </div>
                                    </div>
                                </Fragment>
                                )
                            )
                            }

                         
                            <hr />
                        </div>

                        <div className="col-12 col-lg-3 my-4">
                            <div id="order_summary">
                                <h4>Order Summary</h4>
                                <hr />
                                <p>Subtotal:  <span className="order-summary-values">{cartvalue.reduce((acc,item)=>(acc+item.quantity),0)} (Units) </span></p>
                                <p>Est. total: <span className="order-summary-values">{cartvalue.reduce((acc,item) => (acc+ Number(item.quantity*item.Price)),0)} </span></p>
                
                                <hr />
                                <button id="checkout_btn"  className="btn btn-primary btn-block">Check out</button>
                            </div>
                        </div>
                    </div>
                </Fragment>
            }
           
        </Fragment>
        
    )
}
export default Cartt;





        